<payee-popup title="Hitelező törlése">
  <div class="flex vcenter">
    <span>Hitelező neve: {{ client.name }}</span>
  </div>
  <div class="flex vcenter">
    <span>Hitelező adószáma: {{ client.tax_number }}</span>
  </div>
  <ng-template #payeePopupSubmitTemplate>
    <button
      payee-button
      width="max"
      [disabled]="submitLoading"
      (click)="submit()"
    >
      Törlés
    </button>
  </ng-template>
  <ng-template #payeePopupCancelTemplate>
    <button
      payee-button
      color="alert-red"
      width="max"
      mat-dialog-close
    >
      Mégse
    </button>
  </ng-template>
</payee-popup>
